import React, { Component } from 'react';
import * as store from '../../api/localStore';
import Tenant from '../../util/tenant';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as CoreActions from '../../core/actions/coreActions';
import * as AuthActions from '../actions/authActions';
import * as ProfileActions from '../../profile/actions/profileActions';
import MerchantSelection from './merchantSelection';
import Controls from '../../util/controls';

class RequireAuth extends Component {
    constructor(props) {
        super(props);

        this.isValidTenant = this.isValidTenant.bind(this);
        this.isLoggedIn = this.isLoggedIn.bind(this);
        this.onSelectMerchant = this.onSelectMerchant.bind(this);
    }

    componentDidMount() {
        const { actions, coreActions, profileActions, auth: { userName, selectedMerchantId } } = this.props;
        const tenantName = Tenant.getName();
        
        if (!this.isValidTenant())
            browserHistory.replace('/auth?mode=mobileverification');
        else if (!this.isLoggedIn())
            browserHistory.replace('/auth?mode=login');
        else {
            actions.restoreAuthorisation();
            coreActions.getFeatures(tenantName);

            if (selectedMerchantId)
                coreActions.getMerchantInfo(tenantName, selectedMerchantId);
            else if (userName)
                profileActions.getMerchants(userName, tenantName);
        }
    }

    componentDidUpdate(prevProps) {
        const { auth: { userName, selectedMerchantId }, coreActions, profileActions } = this.props;
        const tenantName = Tenant.getName();

        if (this.isLoggedIn()) {
            if (prevProps.auth.selectedMerchantId != selectedMerchantId && selectedMerchantId)
                coreActions.getMerchantInfo(tenantName, selectedMerchantId);

            if ((prevProps.auth.selectedMerchantId && !selectedMerchantId) || (prevProps.auth.userName != userName && userName))
                profileActions.getMerchants(userName, tenantName);
        }
    }

    isValidTenant() {
        return Tenant.getName() != 'invalid';
    }

    isLoggedIn() {
        return this.isValidTenant() && store.get('token');
    }

    onSelectMerchant(clientMerchantPair) {
        this.props.actions.setSelectedMerchant(clientMerchantPair);
        browserHistory.push('/');
    }

    render() {
        return this.isLoggedIn() ? (
            <div>
                {this.props.auth.selectedMerchantId ? this.props.children : this.props.profile.merchantsLoading ? (
                    <Controls.LoadingPanel />
                ) : (
                    <MerchantSelection handleMerchantSelection={this.onSelectMerchant} merchants={this.props.profile.merchants} />
                )}
            </div>
        ) : null;
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        profile: state.profile
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AuthActions, dispatch),
        coreActions: bindActionCreators(CoreActions, dispatch),
        profileActions: bindActionCreators(ProfileActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth);


// WEBPACK FOOTER //
// ./app/auth/components/requireAuth.js